/**
 * @deprecated This file is being moved to
 * packages/tekion-business/src/appServices/parts/constants/partEntitytypes.js,
 * Kindly make use of that file instead.
 */
var PART_ENTITY_TYPES = {
  FULFILMENT: 'FULFILMENT',
  PNA: 'PNA',
  SALES_ORDER: 'SALES_ORDER',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  SPECIAL_ORDER_REQUEST: 'SPECIAL_ORDER_REQUEST',
  PHYSICAL_INVENTORY: 'PHYSICAL_INVENTORY',
  PART_INVENTORY: 'PART_INVENTORY',
  PARTS_RECEIVING: 'PARTS_RECEIVING'
};
export default PART_ENTITY_TYPES;